






























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getMineActivityInfo,
  getInvitationBuyCourseProgress,
  getInvitationCardFollowList
} from "@/api";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";
import UserTable from "@/components/UserTable.vue";
import {
  IActivity,
  IMyBuyInfo,
  IMyFollowInfo,
  IPageParams,
  IRankUser
} from "@/types";

enum EStatus {
  opened = "opened",
  closed = "closed"
}
enum ERankType {
  follow = "follow",
  buy = "buy"
}
@Component({
  components: {
    MyFooter,
    Rule,
    UserTable
  }
})
export default class My extends Vue {
  $refs!: {
    scroll: HTMLElement;
    end: HTMLElement;
  };
  @Prop({ type: Number, required: true }) actId!: number;
  ERankType = ERankType;
  loading: boolean = true;
  type: ERankType = ERankType.follow;
  activity: IActivity = {
    configurationText: {
      banner: {}
    }
  } as IActivity;
  myBuyInfo: IMyBuyInfo = {
    count: 0,
    buyCourseUsers: [] as IRankUser[],
    invitedUsers: [] as IRankUser[],
    invitationBuyCourseUserInfo: {
      completedNum: 0
    }
  } as IMyBuyInfo;
  myFollowInfo: IMyFollowInfo = {
    count: 0,
    invitedUsers: [] as IRankUser[],
    invitationCardInfo: {
      completedNum: 0
    }
  } as IMyFollowInfo;
  buyPageParams = {
    page: 0,
    limit: 10,
    loading: false,
    end: false
  };
  followPageParams = {
    page: 0,
    limit: 10,
    loading: false,
    end: false
  };
  get pageLoading() {
    return this.buyPageParams.loading || this.followPageParams.loading;
  }
  get buyCourseInfo() {
    const info = {
      title: "",
      emptyTips: "进度为0，快去邀请小伙伴学习课程吧～"
    };
    const now = Math.round(Date.now() / 1000);
    const completedNum = this.myBuyInfo.invitationBuyCourseUserInfo
      .completedNum;
    const completedInfo = this.myBuyInfo.invitationBuyCourseUserInfo
      .completedInfo;
    if (!completedInfo) return info;
    const minRequireNum = completedInfo[0].requireNum;
    if (now >= this.activity.endTime) {
      if (completedNum < minRequireNum) {
        info.title = `共${completedNum}人已购买，很遗憾没完成任务`;
      } else {
        info.title = `共${completedNum}人已购买，恭喜完成任务`;
      }
    } else {
      if (completedNum < minRequireNum) {
        info.title = `${completedNum}人已购买，还差${minRequireNum -
          completedNum}人完成第1阶段任务`;
      } else {
        let stage = 0;
        for (const i in completedInfo) {
          if (completedNum < completedInfo[i].requireNum) {
            break;
          }
          stage++;
        }
        info.title = `太棒了，你完成了第${stage}阶段任务`;
      }
    }
    return info;
  }
  get buyInvitationInfo() {
    const completedNum = this.myBuyInfo.count;
    return {
      title: `${completedNum}人已邀请`,
      emptyTips: "进度为0，快去邀请小伙伴学习课程吧~"
    };
  }
  get followInvitationInfo() {
    const info = { title: ``, emptyTips: "还没有人关注呢，快去邀请关注吧~" };
    const completedNum = this.myFollowInfo.invitationCardInfo.completedNum;
    const completedRequireNum = this.myFollowInfo.invitationCardInfo
      .completedRequireNum;
    const now = Math.round(Date.now() / 1000);
    if (completedNum < completedRequireNum) {
      if (now >= this.activity.endTime) {
        info.title = `共${completedNum}人已关注，很遗憾没完成任务`;
      } else {
        info.title = `${completedNum}人已关注，还差${completedRequireNum -
          completedNum}人`;
      }
    } else {
      info.title = `太棒了，你完成了关注任务`;
    }
    return info;
  }
  get configurationText() {
    return this.activity.configurationText;
  }
  get activityRule() {
    return this.configurationText.activityRule;
  }
  get isShowSwitchTabs(): boolean {
    return !!(
      this.activity.status === EStatus.opened &&
      this.activity.inviteBuyStatus === EStatus.opened
    );
  }
  get isCaizhiActivity() {
    return !!this.activity.isCaizhiActivity;
  }
  @Watch("actId", { immediate: true })
  async getMineActivityInfo(actId: number) {
    this.loading = true;
    this.activity = await getMineActivityInfo(actId);
    if (this.activity.configurationText.pageTitle) {
      document.title = this.activity.configurationText.pageTitle;
    }
    this.$rulePopup({
      value: false,
      rule: this.activity.configurationText.activityRule.content
    });
    this.loading = false;
    if (this.activity.inviteBuyStatus === EStatus.opened) {
      this.type = ERankType.buy;
      const info = await this.findBuyUsers(actId);
      Object.assign(this.myBuyInfo, info);
    }
    if (this.activity.status === EStatus.opened) {
      const info = await this.findFollowUsers(actId);
      Object.assign(this.myFollowInfo, info);
    }
  }
  async findBuyUsers(actId: number = this.actId, pageParams: IPageParams = {}) {
    Object.assign(this.buyPageParams, pageParams);
    if (this.buyPageParams.loading || this.buyPageParams.end) {
      return this.myBuyInfo;
    }
    this.buyPageParams.loading = true;
    const myBuyInfo: IMyBuyInfo = await getInvitationBuyCourseProgress(
      actId,
      this.buyPageParams
    ).catch(err => {
      console.error(err);
      this.buyPageParams.loading = false;
    });
    this.buyPageParams.loading = false;
    this.buyPageParams.page++;
    if (myBuyInfo.invitedUsers.length < this.buyPageParams.limit) {
      this.buyPageParams.end = true;
    }
    this.myBuyInfo.count = myBuyInfo.count;
    if (myBuyInfo.invitationBuyCourseUserInfo) {
      this.myBuyInfo.invitationBuyCourseUserInfo =
        myBuyInfo.invitationBuyCourseUserInfo;
    }
    this.myBuyInfo.buyCourseUsers = myBuyInfo.buyCourseUsers;
    this.myBuyInfo.invitedUsers = this.myBuyInfo.invitedUsers.concat(
      myBuyInfo.invitedUsers
    );
    return this.myBuyInfo;
  }
  async findFollowUsers(
    actId: number = this.actId,
    pageParams: IPageParams = {}
  ) {
    Object.assign(this.followPageParams, pageParams);
    if (this.followPageParams.loading || this.followPageParams.end) {
      return this.myFollowInfo;
    }
    this.followPageParams.loading = true;
    const myFollowInfo: IMyFollowInfo = await getInvitationCardFollowList(
      actId,
      this.followPageParams
    ).catch(err => {
      console.error(err);
      this.followPageParams.loading = false;
    });
    this.followPageParams.loading = false;
    this.followPageParams.page++;
    if (myFollowInfo.invitedUsers.length < this.followPageParams.limit) {
      this.followPageParams.end = true;
    }
    if (myFollowInfo.invitationCardInfo) {
      this.myFollowInfo.invitationCardInfo = myFollowInfo.invitationCardInfo;
    }
    this.myFollowInfo.invitedUsers = this.myFollowInfo.invitedUsers.concat(
      myFollowInfo.invitedUsers
    );
    return this.myFollowInfo;
  }
  onScroll() {
    const loadHeight = this.$refs.end.offsetTop - window.innerHeight;
    const scrollTop = this.$refs.scroll.scrollTop;
    if (loadHeight - 100 < scrollTop) {
      if (this.type === ERankType.buy) {
        this.findBuyUsers();
      } else if (this.type === ERankType.follow) {
        this.findFollowUsers();
      }
    }
  }
}
